import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import ServicesOverview from '../components/ServicesOverview';
import HowItWorks from '../components/HowItWorks';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';

const HomePage = ({ onGetStarted }) => {
  useEffect(() => {
    document.title = 'Federal IP Office | Premier Legal Services for Business & Intellectual Property';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Federal IP Office provides comprehensive legal services including corporate law, intellectual property protection, trademark registration, business litigation, and immigration law. Trusted by businesses nationwide.');
    }
  }, []);

  return (
    <div data-testid="home-page">
      <HeroSection onGetStarted={onGetStarted} />

      {/* Informative Section */}
      <section className="py-24 md:py-32 bg-white" data-testid="home-info-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="text-sm uppercase tracking-[0.2em] font-medium text-[#2C3E50] mb-4">
                About Our Practice
              </div>
              <h2 className="text-3xl lg:text-4xl tracking-tight text-[#2E2E2E] font-bold mb-6">
                Committed to Delivering Results-Driven Legal Counsel
              </h2>
              <p className="text-base leading-relaxed text-[#2E2E2E]/80 mb-6">
                At Federal IP Office, we combine deep industry knowledge with a client-centered approach to deliver legal solutions that protect your business interests. Our team of experienced attorneys works across multiple practice areas to provide comprehensive support for companies of all sizes.
              </p>
              <p className="text-base leading-relaxed text-[#2E2E2E]/80 mb-8">
                From safeguarding your intellectual property to navigating complex regulatory environments, we partner with you to anticipate challenges and seize opportunities. Every engagement is built on transparency, strategic thinking, and an unwavering commitment to your success.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="border-l-2 border-[#2C3E50] pl-4">
                  <h3 className="text-lg font-semibold text-[#2C3E50] mb-1">Multi-Disciplinary</h3>
                  <p className="text-sm text-[#2E2E2E]/70">Expertise across corporate, IP, and compliance law</p>
                </div>
                <div className="border-l-2 border-[#2C3E50] pl-4">
                  <h3 className="text-lg font-semibold text-[#2C3E50] mb-1">Client-Focused</h3>
                  <p className="text-sm text-[#2E2E2E]/70">Tailored strategies for your specific business needs</p>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://images.pexels.com/photos/7841469/pexels-photo-7841469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Legal team consultation at Federal IP Office"
                className="w-full h-[500px] object-cover shadow-lg"
                data-testid="home-info-image"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <HowItWorks />
      <WhyChooseUsSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection onGetStarted={onGetStarted} />
    </div>
  );
};

export default HomePage;
